<template>
  <component :is="fieldLayoutComponent" ref="field" :content="content" :show-get-help="showRequestHelpPrompt">
    <trix-text-input ref="input" :input-name="field" :value="value" :validation-errors="validationErrors"
                     :placeholder="placeholderText" :show-html-mode="false" :show-attach-files="false"
                     :show-code-button="false" :show-heading-button="false" @input="updateFieldValue" />
  </component>
</template>

<script>
import FieldLayout from './field-layout'
import FieldMixin from './field-mixin'
import TrixTextInput from '@/components/inputs/trix-text-input'

export default {
  components: { TrixTextInput },

  mixins: [ FieldMixin ],

  props: {
    fieldLayoutComponent: {
      type: Object,
      required: false,
      default() { return FieldLayout}
    },
    placeholderText: {
      type: String,
      required: false
    }
  },

  methods: {
    focus() {
      this.$refs.input.focus()
    }
  }
}
</script>

<style lang="scss" scoped>
@use "~common_styles/breakpoints" as breakpoints;

::v-deep(textarea) {
  height: 200px;

  @include breakpoints.screen-mobile-only {
    height: 150px;
  }
}
</style>
